export default __webpack_public_path__ + "static/media/black_heart.c33604f9.svg";